import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';
import { POSITION_STATUS } from 'domain/shared/newVacancy';

const LabelCandidateRejected = () => {
  const { data } = useShowContext();
  const { status, isCandidateRejected } = data.getData();

  if (status !== POSITION_STATUS.CLOSED) {
    return null;
  }

  if (!isCandidateRejected) {
    return null;
  }

  return (
    <Badge
      sx={{
        marginLeft: '0',
        right: 0,
        paddingX: '5px',
        height: 25,
      }}
      color="error"
    >
      Candidate rejected
    </Badge>
  );
};

export default LabelCandidateRejected;
